import styled from 'styled-components';

export const Title = styled.div`
  font-size: 18px;
  text-align: center;
`;

export const Container = styled.div`
  padding: 15px 10px;
`;

export const DropdownOption = styled.div`
  padding: 0 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 40px;
  white-space: nowrap;
  width: 100%;
  box-sizing: border-box;
  &:hover {
    background-color: ${({ theme }) => theme.palette.background.default};
  }
`;

export const NameDiv = styled.div`
  font-size: 17px;
  color: ${({ theme }) => theme.palette.info.main};
  margin-left: 5px;
  margin-right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;
